import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import Layout from "./components/Layout";
import LoginPage from "./pages/Login";
import AdminDashboard from "./pages/admin/Dashboard";
import Employees from "./pages/admin/Employees";
import AdminAttendance from "./pages/admin/Attendance";
import Reimbursements from "./pages/admin/Reimbursements";
import AdminSalary from "./pages/admin/Salary";
import Payments from "./pages/admin/Payments";
import DBConfig from "./pages/admin/DBConfig";
import EmployeeDashboard from "./pages/employee/Dashboard";
import EmployeeAttendance from "./pages/employee/Attendance";
import EmployeeBills from "./pages/employee/Bills";
import EmployeeSalary from "./pages/employee/Salary";
import EmployeePayslips from "./pages/employee/Payslips";

const ProtectedRoute = ({ role, children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex items-center justify-center h-screen text-sm eyebrow text-zinc-500">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) return <Navigate to={user.role === "admin" ? "/admin" : "/employee"} replace />;
  return children;
};

const RootRedirect = () => {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "admin" ? "/admin" : "/employee"} replace />;
};

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/" element={<RootRedirect />} />
            <Route path="/login" element={<LoginPage />} />

            <Route element={<ProtectedRoute role="admin"><Layout /></ProtectedRoute>}>
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/employees" element={<Employees />} />
              <Route path="/admin/attendance" element={<AdminAttendance />} />
              <Route path="/admin/reimbursements" element={<Reimbursements />} />
              <Route path="/admin/salary" element={<AdminSalary />} />
              <Route path="/admin/payments" element={<Payments />} />
              <Route path="/admin/db-config" element={<DBConfig />} />
            </Route>

            <Route element={<ProtectedRoute role="employee"><Layout /></ProtectedRoute>}>
              <Route path="/employee" element={<EmployeeDashboard />} />
              <Route path="/employee/attendance" element={<EmployeeAttendance />} />
              <Route path="/employee/bills" element={<EmployeeBills />} />
              <Route path="/employee/salary" element={<EmployeeSalary />} />
              <Route path="/employee/payslips" element={<EmployeePayslips />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
